// extracted by mini-css-extract-plugin
export var close = "cookie-popup-module--close--1LMvo";
export var container = "cookie-popup-module--container--5crGi";
export var content = "cookie-popup-module--content--FTsNQ";
export var overlay = "cookie-popup-module--overlay--pnnU9";